import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

function resolveThinStrokeWidth(strokeWidth: LucideProps['strokeWidth']) {
  return typeof strokeWidth === 'number' ? Math.min(strokeWidth, 1.25) : 1.25;
}

export const MessageBusGraphIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ color = 'currentColor', size = 24, strokeWidth = 2, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M7.25 12h.55m1.5-1.2 4.7-5m-4.7 7.4 4.7 5"
        strokeWidth={resolveThinStrokeWidth(strokeWidth)}
      />
      <path d="m9.3 10.5 1.5 1.5-1.5 1.5-1.5-1.5z" fill={color} stroke="none" />
      <rect x="0.75" y="8.75" width="6.5" height="6.5" rx="0.75" />
      <path d="m1.25 9.7 2.75 2.4 2.75-2.4" strokeWidth={resolveThinStrokeWidth(strokeWidth)} />
      <rect x="16.25" y="0.75" width="6.5" height="6.5" rx="0.75" />
      <path d="m16.75 1.7 2.75 2.4 2.75-2.4" strokeWidth={resolveThinStrokeWidth(strokeWidth)} />
      <rect x="16.25" y="16.75" width="6.5" height="6.5" rx="0.75" />
      <path d="m16.75 17.7 2.75 2.4 2.75-2.4" strokeWidth={resolveThinStrokeWidth(strokeWidth)} />
    </svg>
  )
);

MessageBusGraphIcon.displayName = 'MessageBusGraphIcon';
